import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'components';
import { Container } from 'utils';
import { Tabs, Spin, Switch, Row, Col, message } from 'antd';
import styled from '@emotion/styled';
import PromotionCategoriesTable from './components/PromotionCategoriesTable';
import PromotionItemsTable from './components/PromotionItemsTable';
import { adminServices } from 'services';
import { AlertActions } from 'redux/actions';
import { getPromotionModuleStatus, togglePromotionModule } from 'services/PromotionModuleSettingsService';
import './style.css';

const { TabPane } = Tabs;

const PageWrapper = styled.div`
  padding: 24px 0;
`;

const StyledTabs = styled(Tabs)`
  .ant-tabs-tab {
    font-size: 16px;
    padding: 12px 24px !important;
    font-weight: 500;
  }
  .ant-tabs-content {
    margin-top: 24px;
  }
`;

class PromotionManagement extends Component {
  state = {
    loading: false,
    categories: [],
    items: [],
    activeTab: '1',
    promoModuleEnabled: false,
    promoModuleLoading: false,
  };

  componentDidMount() {
    this.fetchData();
    this.fetchPromoModuleStatus();
  }

  fetchPromoModuleStatus = async () => {
    this.setState({ promoModuleLoading: true });
    try {
      const res = await getPromotionModuleStatus();
      this.setState({ promoModuleEnabled: !!res.enabled });
    } catch (e) {
      message.error('');
    } finally {
      this.setState({ promoModuleLoading: false });
    }
  };

  handleTogglePromoModule = async () => {
    this.setState({ promoModuleLoading: true });
    try {
      const res = await togglePromotionModule();
      this.setState({ promoModuleEnabled: !!res.enabled });
      message.success(
        `Das Promotion-Modul wurde ${
          res.enabled ? 'aktiviert' : 'deaktiviert'
        }.`
      );
    } catch (e) {
      message.error('Das Promotion-Modul konnte nicht geändert werden.');
    } finally {
      this.setState({ promoModuleLoading: false });
    }
  };

  fetchData = async () => {
    this.setState({ loading: true });
    try {
      const [categories, items] = await Promise.all([
        adminServices.getPromotionCategories(),
        adminServices.getPromotionItems()
      ]);
      this.setState({ categories, items });
    } catch (error) {
      AlertActions.error('Failed to load data', 'Error');
    } finally {
      this.setState({ loading: false });
    }
  };

  refreshCategories = async () => {
    try {
      const categories = await adminServices.getPromotionCategories();
      this.setState({ categories });
    } catch (error) {
      AlertActions.error('Failed to refresh categories', 'Error');
    }
  };

  refreshItems = async () => {
    try {
      const items = await adminServices.getPromotionItems();
      this.setState({ items });
    } catch (error) {
      AlertActions.error('Failed to refresh items', 'Error');
    }
  };

  handleTabChange = (key) => {
    this.setState({ activeTab: key });
  };

  render() {
    const { loading, categories, items, activeTab, promoModuleEnabled, promoModuleLoading } = this.state;

    return (
      <Spin spinning={loading}>
        <Layout>
          <Container>
            <PageWrapper className="promotion-management">
              <Row style={{ marginBottom: 24, position: 'absolute', right: 25, top: 48, zIndex: 998 }} align="middle" gutter={16}>
                <Col>
                  <b>Promotion-Modul aktiv/inaktiv:</b>
                </Col>
                <Col>
                  <Switch
                    checked={promoModuleEnabled}
                    loading={promoModuleLoading}
                    onChange={this.handleTogglePromoModule}
                  />
                </Col>
              </Row>
              <StyledTabs
                activeKey={activeTab}
                onChange={this.handleTabChange}
                size="large"
              >
                <TabPane tab="Promotion Kategorien" key="1">
                  <PromotionCategoriesTable
                    categories={categories}
                    onRefresh={this.refreshCategories}
                  />
                </TabPane>
                <TabPane tab="Promotion Items" key="2">
                  <PromotionItemsTable
                    items={items}
                    categories={categories}
                    onRefresh={this.refreshItems}
                  />
                </TabPane>
              </StyledTabs>
            </PageWrapper>
          </Container>
        </Layout>
      </Spin>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.projects?.loading || false,
});

export default connect(mapStateToProps)(PromotionManagement);
